import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AlertComponent } from 'src/app/structure/alert/alert.component';
import { environment } from 'src/environments/environment';
declare var $: any;
import * as _ from 'lodash';
import { MbpService } from 'src/app/services/mbp.service';
@Component({
  selector: 'app-mbp2list',
  templateUrl: './mbp2list.component.html',
  styleUrls: ['./mbp2list.component.css']
})
export class Mbp2listComponent implements OnInit {

  public environmentSettings: any;

  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  dtOptionsOfRegisterDirector: DataTables.Settings = {};
  registerDirectorList: any[];
  masterDirectorList: any[];
  FromDateModelInMasterDirector: any;
  ToDateModelInMasterDirector: any;
  dtTriggerRegisterDirector: Subject<any> = new Subject();
  error: any = { isError: false, errorMessage: '' };
  response: boolean;
  deleteMbpId: any;
  clientIdDPno: any;
  natureOfTransaction: any;
  //natureOfTransaction = '';
  futureToDate: NgbDateStruct;
  futureToDateTo: NgbDateStruct;
  
  dateOfMakingLoan: any;
  nameOfPerson: any;
  editParticularId: any;
  dateLoan:any;
  dateLoanTo:any;
  dateOfGuarantee : any;
  dateOfGuaranteeTo : any;
  dateOfInvestment : any;
  dateOfInvestmentTo:any;
  isSearchDivVisible = false;

  constructor(private mbpService: MbpService, private router: Router, private alert: AlertComponent,private activatedRoute: ActivatedRoute) {
    this.response = false;
  }
  ngOnInit() {
    this.environmentSettings = environment;
    this.dtOptionsOfRegisterDirector = {
      destroy: true,
      scrollX: true,
      scrollY: "210px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [16] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'MBP2',
          title: 'MBP-2 Loans, Guarantee, Security and Acquisition made by Company',
          extend: 'excel',
          exportOptions: {
            columns: [0, 1, 3, 5, 7, 9, 11, 13, 15],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }
        }
      ]
    };
    this.getMbpList();
  }

  getMbpList() {
    this.registerDirectorList = [];
    this.mbpService.getMbpList({ isSearch: false }).subscribe(registerList => {
      $("#mbpmasterlistTable").DataTable().destroy();
      this.registerDirectorList = registerList.data;
      this.dtTriggerRegisterDirector.next();
      // setTimeout(() => {
      //   this.dtTriggerRegisterDirector.next();
      // }, 200);
    });
  }
  add(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['mbp2','add']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }
  confirmDelete(id) {
    this.deleteMbpId = id;
    $("#deleteConfirm").modal('toggle');
  }

  deletembpdetail() {
    this.mbpService.removembpdetails(this.deleteMbpId)
      .subscribe(response => {
        if (response.status == 0) {
          this.alert.success(response.message);
          $("#mbpmasterlistTable").DataTable().destroy();
          $("#deleteConfirm").modal('toggle');
          this.getMbpList();
        } else {
          this.alert.error(response.message);
        }
      });
  }

  editmbp(_id) {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['mbp2','edit',_id]  } }],
      { relativeTo: this.activatedRoute.parent });
    // this.router.navigate(['mbp2/edit/', _id]);
  }
  generateOutput() {
    let companyId = JSON.parse(localStorage.getItem('companyDetails')).companyID;
    var object = {
      id: null,
      fromDate: this.dateLoan,
      toDate: this.dateLoanTo,
      name: this.nameOfPerson,
      param1: this.clientIdDPno,
      param2: this.natureOfTransaction
    }
    this.mbpService.generateMbpDocument(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(companyId);
          setTimeout(function () {
            self.downloadPdfDocument(companyId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.mbpService.downloadMbpFile(id, 'Multi');
  }
  downloadPdfDocument(id) {
    this.mbpService.downloadMbpPdfFile(id, 'Multi');
  }

  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }

  doAdvSearch() {
    this.response = true;
    var searchParam =
    {
      "clientIdDPno": this.clientIdDPno,
      "natureOfTransaction": this.natureOfTransaction,
      "dateOfMakingLoan": this.setDate(this.dateOfMakingLoan),
      "nameOfPerson": this.nameOfPerson,

      "dateLoan": this.setDate(this.dateLoan),
      "dateLoanTo": this.setDate(this.dateLoanTo),
      // "dateOfGuarantee": this.setDate(this.dateOfGuarantee),
      // "dateOfGuaranteeTo": this.setDate(this.dateOfGuaranteeTo),
      // "dateOfInvestment":this.setDate(this.dateOfInvestment),
      // "dateOfInvestmentTo":this.setDate(this.dateOfInvestmentTo),
      'isSearch': true,
    };
    this.registerDirectorList = [];
    $("#mbpmasterlistTable").DataTable().destroy();
    this.mbpService.getMbpList(searchParam).subscribe(registerList => {
      this.response = false;
      this.registerDirectorList = registerList.data;
      this.dtTriggerRegisterDirector.next();
    });
  }
  clearAdvSearch() {
    this.clientIdDPno = ''
    this.natureOfTransaction = '';
    this.dateOfMakingLoan = undefined;
    this.nameOfPerson = '';
    this.dateLoan = undefined;
    this.dateLoanTo = undefined;
    // this.dateOfGuarantee= undefined;
    // this.dateOfGuaranteeTo= undefined;
    // this.dateOfInvestment = undefined;
    // this.dateOfInvestmentTo = undefined;
    $("#mbpmasterlistTable").DataTable().destroy();
    this.getMbpList();
    this.response = false;
  }


  // natureOfTransactionChange() {
  //   if (this.natureOfTransaction == 'loan') {
  //     this.dateLoan = '';
  //     this.dateLoanTo ='';
  //   } else if(this.natureOfTransaction == 'G/s') {
  //     this.dateOfGuarantee = '';
  //     this.dateOfGuaranteeTo = '';
  //   }
  //   else if(this.natureOfTransaction == 'investment') {
  //     this.dateOfInvestment = '';
  //     this.dateOfInvestmentTo = '';
  //   }
  // }
}

